import { BaseClient } from '../base-client';
import type { InvoiceSettings, UpdateInvoiceSettingsInput } from './types';

/** `data` is null when the tenant has never configured invoicing. */
type SettingsResponse = { data: InvoiceSettings | null };
type SavedResponse = { data: InvoiceSettings };

export class InvoiceSettingsClient extends BaseClient {
  /** The tenant's issuer block, remittance instructions and invoice defaults.
   *  Returns `{ data: null }` when nothing has been saved yet. */
  get(): Promise<SettingsResponse> {
    return this.request('/api/invoice-settings');
  }

  /** Create or replace the tenant's invoice settings. Full replace — send
   *  every field. */
  update(input: UpdateInvoiceSettingsInput): Promise<SavedResponse> {
    return this.request('/api/invoice-settings', { method: 'PUT', body: input });
  }
}
